export default function getParkingType({
    isMonthly,
    isAirport,
    isEvent,
    isEventPackage,
}) {
    return isAirport
        ? 'airport'
        : isEvent
        ? 'event'
        : isEventPackage
        ? 'event_package'
        : isMonthly
        ? 'monthly'
        : 'transient';
}
